<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span> Traveller List</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->
      <div class="container-fluid">
        <div class="row">
          <Sidebar />

          <div class="col-lg-10 mt-3">
            <form @submit.prevent="searchJourney()">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Journey With</label>
                    <select
                      v-model="search.journey_type"
                      class="form-control select2"
                    >
                      <option value="">-Select-</option>
                      <option value="friends">Friends</option>
                      <option value="family">Family</option>
                      <option value="self">Self</option>
                      <option value="couple">Couple</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4">
                  <label>Travel From</label>
                   <vue-simple-suggest
                      v-model="search.from"
                      display-attribute="name"
                      value-attribute="url"
                      :list="getSuggestionList"
                      ></vue-simple-suggest>
                </div>
                <div class="col-lg-4">
                  <label>Travel To </label>
                   <vue-simple-suggest
                      v-model="search.to"
                      display-attribute="name"
                      value-attribute="url"
                      :list="getSuggestionList1"
                      ></vue-simple-suggest>
                </div>
                <div class="col-lg-5">
                  <label>Categories</label>
                  <select2-multiple-control
                    :options="catOptions"
                    :settings="{
                      multiple: true,
                    }"
                    multiple
                    @select="catSelectEvent($event)"
                  />
                </div>

                <div class="col-lg-5">
                  <label>Sub Categories</label>
                  <select2-multiple-control
                    :options="subCatOptions"
                    :settings="{ multiple: true }"
                    @select="subcatselectEvent($event)"
                    placeholder="-Select Categories-"
                  />
                </div>
                <div class="col-md-2">
                  <center>
                    <button type="submit" class="btn_1 add_top_30 mb-4">
                      Search
                    </button>
                  </center>
                </div>
              </div>
              <a
                class="sendoffer"
                style="cursor: pointer"
                harf="javascript:void(0);"
                @click="openModel2()"
                >Send Offer</a
              >
            </form>
            <hr />
            <div class="">
              <table
                id="dtBasicExample"
                class="table table-striped table-bordered table-sm"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th scope="col">
                      <input
                        type="checkbox"
                        v-model="all"
                        @click="checkAll()"
                        id="allCheck"
                      />
                    </th>
                    <th scope="col">Name</th>
                    <th scope="col">Journey Name</th>
                    <th scope="col">From Date</th>
                    <th scope="col">To Date</th>
                    <th scope="col">Travelling From</th>
                    <th scope="col">Travelling To</th>
                    <th scope="col">Journey Type</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(journey, index) in journeyList" :key="journey.id">
                    <td>
                      <input
                        type="checkbox"
                        v-model="checked[index]"
                        id="journey"
                        :key="index"
                        @click="checkonce(journey.id, journey.user_id)"
                      />
                    </td>
                    <!-- <td >{{ index + 1 }}</td> -->
                    <td>
                      <span v-for="user in journey.users" :key="user.id">
                        {{ user.firstname }} {{ user.lastname }}</span
                      >
                    </td>
                    <td>
                      {{ journey.journey_name }}<br />
                      <span
                        v-for="category in journey.categories"
                        :key="category.id"
                      >
                        {{ category.category }},</span
                      >
                    </td>
                    <td>{{ frontEndDateFormat(journey.from_date) }}</td>
                    <td>{{ frontEndDateFormat(journey.to_date) }}</td>
                    <td>{{ journey.travelling_from }}</td>
                    <td>{{ journey.travelling_to }}</td>
                    <td>{{ journey.journey_type }}</td>
                    <td>
                      <a
                        class="New"
                        href="javascript:void(0);"
                        @click="openModel(journey.id, journey.user_id)"
                        >Send Offer</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                class="modal fade bd-example-modal-lg"
                tabindex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <form v-if="offerLink.length >0"
                      @submit.prevent="replyJourney()"
                      style="padding: 20px"
                    >
                      <h3>SEND OFFER</h3>
                      <hr />
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <select
                              class="form-control select2"
                              v-model="offersend"
                            >
                              <option selected value="">-Select-</option>
                              <option
                                :value="offer.id"
                                v-for="offer in offerLink"
                                :key="offer.id"
                              >
                                {{ offer.short_description }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <textarea
                              class="form-control"
                              rows="8"
                              v-model="offerSummary"
                            ></textarea>
                            <input type="hidden" v-model="jid" />
                            <input type="hidden" v-model="uid" />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label
                              ><input
                                type="checkbox"
                                v-model="check1"
                                checked
                                disabled
                              />
                              Website
                            </label>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label
                              ><input
                                type="checkbox"
                                v-model="check2"
                                value="sms"
                              />
                              SMS
                            </label>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label
                              ><input
                                type="checkbox"
                                v-model="check3"
                                value="email"
                              />
                              Email
                            </label>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <button class="New btn_1 full-width purchase">
                              Send Offer
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div class="p-5">
                      <h5>No Offer Available please Create And Offer</h5>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /cart-options -->
            </div>
          </div>
          <!-- /col -->
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->

      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
// import axios from 'axios'
// import Alert from "../cmps/Alert";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import API from "../services/index";
import moment from "moment";
import jQuery from "jquery";
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
/*eslint-disable */

export default {
  data() {
    return {
      checked: [],
      offerSummary: "",
      offerLink: [],
      check1: "web",
      check2: "",
      check3: "",
      jid: "",
      uid: "",
      search: {
        journey_type: "",
        from: "",
        to: "",
      },
      searchcat: {
        categories: [],
        subcategories: [],
      },
      pointmsg: "",
      one: false,
      offers: [],
      catOptions: [],
      subCatOptions: [],
      journeyList: [],
      dt: null,
      msg: null,
      roleId: localStorage.getItem("role_id"),
      all: false,
      reply: {
        user_id: [],
        journey_id: [],
      },
      offersend: null,
    };
  },

  beforeMount() {
    this.getjourneyList();
    this.ShowList();
    this.checkToken();
    this.getParentCategories();
  },

  methods: {
    ShowList: function () {
      //alert(this.search.is_active);
      const token = "Bearer " + localStorage.getItem("token");
      const role_id = localStorage.getItem("role_id");
      const form = new FormData();
      form.append("role_id", role_id);
      form.append("search", JSON.stringify(this.search));
      //var data = { role_id: role_id, search: this.search };
      API.post("offer/get_offer_by_vendorId", form, {
        headers: { Authorization: token },
      })
        .then((response) => {
          this.offerLink = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
     getSuggestionList () {
      var i =[]
      if (this.search.from.length >= 2) {
       return API.get(`https://location.securebrandtech.com/auto/api?q=${this.search.from}`)
          .then(function (response) {
          response.data.features.forEach(function (feature) {
            i.push(feature.properties.name +' '+ feature.properties.county+' '+' '+ feature.properties.state+' '+ feature.properties.postcode ) 
            })
            var uniq = [ ...new Set(i) ];
            return uniq 
            
          })

          .catch(function (error) {
            console.log(error);
          });
      }
    },
      getSuggestionList1 () {
      var i =[]
      if (this.search.to.length >= 2) {
       return API.get(`https://location.securebrandtech.com/auto/api?q=${this.search.to}`)
          .then(function (response) {
          response.data.features.forEach(function (feature) {
            i.push(feature.properties.name +' '+ feature.properties.county+' '+' '+ feature.properties.state+' '+ feature.properties.postcode ) 
            })
            var uniq = [ ...new Set(i) ];
            return uniq 
            
          })

          .catch(function (error) {
            console.log(error);
          });
      }
    },
    replyJourney: function () {
      const token = localStorage.getItem("token");
      const roleId = localStorage.getItem("role_id");

      const form = new FormData();

      form.append("website", this.check2);
      form.append("email", this.check3);
      form.append("sms", this.check2);
      if (this.reply.user_id.length > 0) {
        form.append("journey_id", this.reply.journey_id);
      } else {
        form.append("journey_id", this.jid);
      }

      API.post(`Userjourney/getjourneyprice`, form, {
        headers: { Authorization: "Bearer " + token },
      }).then((res) => {
        this.$swal({
          title: "Are you sure!",
          text: res.data,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes proceed to journey offer",
          closeOnConfirm: false,
        }).then((isConfirm) => {
          if (!isConfirm.isConfirmed) {
            this.$router.push("/journey-list/");
            return false;
          } else {
            if (roleId == 2) {
              const form = new FormData();
              form.append("website", this.check2);
              form.append("email", this.check3);
              form.append("sms", this.check2);
              form.append("offerlink", this.offersend);
              form.append("offersummary", this.offerSummary);
              if (this.reply.user_id.length > 0) {
                form.append("journey_id", this.reply.journey_id);
                form.append("receiver_id", this.reply.user_id);
              } else {
                form.append("journey_id", this.jid);
                form.append("receiver_id", this.uid);
              }

              API.post(`Userjourney/send_journey`, form, {
                headers: { Authorization: "Bearer " + token },
              })
                .then((res) => {
                  if (res.data.status == 200) {
                    window.$(".bd-example-modal-lg").modal("hide");
                    this.offerLink = "";
                    this.offerSummary = "";
                    this.jid = "";
                    this.uid = "";
                    this.$swal("success	", res.data.messages);
                    this.$router.push({ name: "journeyyList" });
                  } else {
                    this.$swal(res.data.messages);
                  }
                })
                .catch((err) => {
                  console.log(err.response);
                });
            } else {
              this.$swal("Error", "Only For Merchant");
            }
          }
        });
      });
    },
    checkAll() {
      if (this.all) {
        this.reply.journey_id = [];
        this.checked = [];
        this.reply.user_id = [];
      } else {
        this.reply.journey_id = [];
        this.checked = [];
        this.reply.user_id = [];

        this.journeyList.forEach((value) => {
          this.reply.journey_id.push(value.id);
          this.checked.push(value.id);
          this.reply.user_id.push(value.user_id);
        });
      }
    },
    checkonce(id, user_id) {
      const found = this.reply.journey_id.find((element) => element == id);
      if (found) {
        this.reply.journey_id = this.reply.journey_id.filter(
          (item) => item !== found
        );
        var index = this.reply.journey_id.indexOf(found);
        this.reply.user_id.splice(index, 1);
      } else {
        this.reply.journey_id.push(id);
        this.reply.user_id.push(user_id);
      }
      this.reply.journey_id.length != this.checked.length
        ? (this.all = false)
        : (this.all = true);
    },
    openModel(id, uid) {
      this.jid = id;
      this.uid = uid;
      window.$(".bd-example-modal-lg").modal("show");
    },
    openModel2() {
      window.$(".bd-example-modal-lg").modal("show");
    },
    searchJourney() {
      const token = "Bearer " + localStorage.getItem("token");
      const form = new FormData();
      // form.append("subcategories_id", this.search.subcategories);
      form.append("search", JSON.stringify(this.search));
      form.append("categories", JSON.stringify(this.searchcat.categories));
      form.append(
        "subcategories",
        JSON.stringify(this.searchcat.subcategories)
      );
      API.post("Userjourney/search", form, {
        headers: { Authorization: token },
      })
        .then((res) => {
          if (res.data.status == 200) {
            // this.msg = "Your Profile updated Successfully";
            // this.classAlert = "success";
            // this.$router.push({ name: 'UserPost' })
            this.dt = jQuery(".table").DataTable();
            setTimeout(() => (this.journeyList = res.data.data));
          } else {
            this.dt = jQuery(".table").DataTable();
            setTimeout(() => (this.journeyList = res.data.data));
            this.msg = res.data.messages;
            this.classAlert = "danger";
          }
        })
        .catch((err) => {
          this.msg = err;
          this.classAlert = "danger";
        });
    },
    frontEndDateFormat(date) {
      //alert(date);
      return moment(date).format("DD/MM/YYYY hh:mm");
    },
    redirect(offerid, url) {
      //alert(offerid + " " + url);
      this.$router.push(url + "/" + window.btoa(offerid));
    },
    moment: function () {
      return moment();
    },

    getjourneyList() {
      const token = "Bearer " + localStorage.getItem("token");
      // alert(id);
      API.get("Userjourney/journey_all_list", {
        headers: { Authorization: token },
      })
        .then((res) => {
          this.dt = jQuery(".table").DataTable();
          setTimeout(() => (this.journeyList = res.data));
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    getParentCategories() {
      API.get("categories/parent_services_select2list")
        //.get("categories/parent_services")
        .then((res) => {
          this.catOptions = res.data.data;
          // this.search = this.search.categories;
          console.log(res.data.data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    setSubCategory(categoryId, mode) {
      //alert(categoryId);
      // let selSubCat = this.search.subcategories;
      API.get(
        "categories/parent_services_select2list/" + window.btoa(categoryId)
      )
        //.get("categories/parent_services")
        .then((res) => {
          if (mode == "push") {
            res.data.data.forEach((val) => {
              console.log("val=" + JSON.stringify(val));
              this.subCatOptions.push(val);
              //this.subCatOptions.concat(res.data.data);
            });

            //console.log("sub cat options=" + this.subCatOptions);
          } else {
            //this.search.subcategories.push(res.data.data);
            res.data.data.forEach((val) => {
              this.subCatOptions.splice(this.subCatOptions.indexOf(val.id), 1);
            });
          }
          this.searchcat.subcategories = [];
          // this.emitFilterRequest();
          //this.loadNearbyOffers(this.search);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    catSelectEvent(e) {
      var sel = e.selected;
      if (sel) {
        this.setSubCategory(e.id, "push");
        this.searchcat.categories.push(e.id);
      } else {
        this.setSubCategory(e.id, "remove");
        this.searchcat.categories.splice(
          this.searchcat.categories.indexOf(e.id),
          1
        );
      }
    },
    subcatselectEvent(e) {
      var sel = e.selected;
      //alert(sel + " " + e.id + " " + e.text + " " + e.selected);
      if (sel) {
        this.searchcat.subcategories.push(e.id);
      } else {
        this.searchcat.subcategories.splice(
          this.searchcat.subcategories.indexOf(e.id),
          1
        );
      }
      //this.loadNearbyOffers(this.search);
    },

    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        this.$router.push("/signin");
      }
    },
  },
  components: {
    Frontendlayout,
    Sidebar,
    VueSimpleSuggest

  },
  watch: {
    journeyList(val) {
      console.log(val);
      this.dt.destroy();

      this.$nextTick(() => {
        this.dt = jQuery(".table").DataTable({
           processing: true,
                dom: 'Bfrtip',
                    buttons: ['copy', 'csv', 'print'
                    ]
        });
      });
    },
  },
};
</script>
<style  scoped>
@import "../../public/frontend/vendor/dropzone.css";

.journey {
  padding: 30px;
  background: #fff;
}
.fa {
  padding: 0 5px;
}
.sendoffer {
  background: #fc5b62;
  color: #fff;
  padding: 8px 15px;
  border-radius: 5px;
  font-size: 14px;
}
a.New {
  background: #fc5b62;
  color: #fff;
  padding: 5px 8px;
  border-radius: 12px;
  font-size: 10px;
}
a.Read {
  background: #8363db;
  color: #fff;
  padding: 5px 8px;
  border-radius: 12px;
  font-size: 10px;
}
</style>